<template>
    <div class="layout-donate-edit-form">
        <!-- 1、标注内容 -->
        <div class="donate-edit-form-content">
            <p>您是第<span class="donate-edit-number">{{myNum}}</span>位文化复兴大使！</p>
            <p>感谢您的大力支持！</p>
        </div>
        <!-- 2、金额 -->
        <div class="donate-product-list">
            <div class="donate-product-item" v-for="(product, index) in productList" v-bind:key="product.id"><span v-bind:class="{'cur': index == curIndex}" @click="clickItem(index)">¥{{product.price}}</span></div>
        </div>
        <!-- 3、备注输入框 -->
        <div class="donate-input-box">
            <input class="donate-input" type="text" maxlength="10" v-model="inputValue" @focus="focusInput" @blur="blurInput" placeholder="请输入真实姓名，方便今后收录在贡献榜">
        </div>
        <div class="donate-bottom-sub-text">
            <p>文化大使身份将在所有木火通明相关易学产品中<br />以特殊身份头像展示</p>
        </div>

        <!-- 4、底部按钮部分 -->
        <div class="donate-bottom-box">
            <button class="donate-bottom-button" @click="clickDonate" v-if="donateStatus == 0">捐赠并点亮文化大使身份</button>
            <button class="donate-bottom-button" @click="clickDonate" v-if="donateStatus == 1">继续捐赠</button>
        </div>
    </div>
</template>

<script>
import * as doctitle from '../../modules/data/base/doctitle'
import { UA } from '../../modules/utils';
import { DOM } from '../../modules/dom'
export default {
    name: 'DonateEditForm',
    computed: {
        myNum() {
            return this.$store.state.donate.myNum;
        },
        productList() {
            return this.$store.state.donate.productList;
        }
    },
    data() {
        return {
            curIndex: 0,
            inputValue: '',
            donateStatus: 0
        }
    },
    mounted() {
        if(this.productList.length == 0) {
            DOM.showParentPageByClassName('donate-page');
            this.$router.replace('/donate');
        }
        var userInfo = this.$store.state.userData;
        this.donateStatus = userInfo && userInfo.info && userInfo.info.donate ? parseInt(userInfo.info.donate) : this.donateStatus;
        // console.log('DonateEditForm--------mounted', userInfo, this.donateStatus);
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            this.$el.style.overflow = 'hidden';
            var me = this;
            window.onresize = function() {
                me.$el.style.width = innerWidth + 'px';
                me.$el.style.height = innerHeight + 'px';
                me.$el.style.overflow = 'hidden';
            }
        },
        clickItem(index) {
            this.curIndex = index;
        },
        focusInput() {
            // 添加安卓的输入框失去焦点事件监听
            if(UA.isAndroid()) {
                window.onresize = function() {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 100);
                }
            }
        },
        blurInput() {
            // 添加安卓的输入框失去焦点事件监听
            if(UA.isAndroid()) {
                window.onresize = function() {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 100);
                }
            }
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 10);
        },
        clickDonate() {
            // 处理名称
            var userInfo = this.$store.state.userData,
                nickName = userInfo && userInfo.info && userInfo.info.nickname ? userInfo.info.nickname : '某某某',
                extName = this.inputValue != '' ? this.inputValue : nickName;
            console.log('userInfo-----------', userInfo, nickName, extName)

            var productList = this.$store.state.donate.productList,
                productData = productList[this.curIndex];
            console.log('clickDonate-------', this.curIndex, productData.pid, productData.payType[2], extName)

            this.$store.dispatch('donate/startDonate', {
                params: {
                    pid: productData.pid,
                    ptype: productData.payType[2],
                    ext: extName
                },
                sucCb: function(){
                    // 支付成功后跳转到分享页面
                    DOM.setDocumentTitle(doctitle.TITLE_DONATE_SUC);
                },
                failCb: function() {
                    // 支付失败后提示
                    me.$toast('支付失败，请稍后再试一下！')
                }
            })
        }
    }
}
</script>